export const creatToastActionSlice = (set) => ({
    isLoading: false,
    setLoading: (loading) => {
        set((state) => {
            state.toastAction.isLoading = loading;
        });
    },
});
